export default (api) => {
    return {
        index: options => api.get('districts', options),
        get: (district_id, options) => api.get('districts/' + district_id, options),
    }
}
